import type { ClassTransformOptions } from "class-transformer";
import { serialize } from "class-transformer";
import { toJS } from "mobx";
import AxiosApiConnector from "./AxiosApiConnector";
import DeserializingRequestBuilder from "./deserializingRequestBuilder";

const serializeOptions: ClassTransformOptions = {
  excludePrefixes: ["_"],
};

export function serializeEntity(value: any): string {
  return serialize(toJS(value, { recurseEverything: true }), serializeOptions);
}

export type JsonSerializer = (value: any) => string;

export default class BaseConnector extends DeserializingRequestBuilder {
  protected constructor(url: string, cookie: string, jsonSerializer?: JsonSerializer) {
    let requestParams: RequestInit | undefined;
    const accessToken = sessionStorage.getItem(cookie);
    if (accessToken) {
      requestParams = {
        headers: { Authorization: `Bearer ${accessToken}` },
      };
    }
    super(new AxiosApiConnector({ jsonSerializer: jsonSerializer }), url, requestParams);
  }
}
